import Vue from "vue";
import Vuex from "vuex";
import router from "./router";

Vue.use(Vuex);
export default new Vuex.Store({

  state: {
    isLoggedIn: !!localStorage.getItem("token"),
    userType: localStorage.getItem("role"),
    userData: {},
    appLoading: false,
    queryPopUpDialog: false,
    menu:[],
   
  },
  mutations: {
    appLoading(state, payload) {
      state.appLoading = payload;
    },
    queryPopUpDialog(state, payload) {
      state.queryPopUpDialog = payload;
      console.log("queryPopUpDialog",state.queryPopUpDialog)
    },
    menu(state, payload) {
      state.menu = payload
    },
    // sessionOut(state) {
    //   localStorage.removeItem("token");
    //   state.isLoggedIn = false;
    //   router.push("/login"); 
    // },
    userType(state, payload) {
      state.userType = payload
      // localStorage.setItem("role", payload)
    },
    userData(state, payload) {
      state.userData = payload 
    },
    loginUser(state, payload) {
      localStorage.setItem("token", payload);
      state.isLoggedIn = true;
      state.userType = localStorage.getItem("role");
      console.log("isloggedin=",state.isLoggedIn)
      console.log("userType=",state.userType)
      if (state.isLoggedIn == true && state.userType == 'SuperAdmin') {
        router.push("/home") 
      }
      else if (state.isLoggedIn == true && state.userType == 'ConstituencyPresident') {
        router.push("/PresidentDashboard") 
      }
      else if (state.isLoggedIn == true && state.userType == 'Aspirant') {
        router.push("/CandidateDashboard") 
      }
      //
      else if (state.isLoggedIn == true && state.userType == 'BoothPresident') {
        router.push("/UserDashboard") 
      }
      else if (state.isLoggedIn == true && state.userType == 'BoothAgent') {
        router.push("/UserDashboard") 
      }
    },
    logoutUser(state) {
      state.userType = null;
      state.isLoggedIn = false;
      state.userData = {};
      state.initial = "";
      localStorage.removeItem("role");
      localStorage.removeItem("token");
      localStorage.clear();
      console.log("store logiut")
      router.push("/");

    },
    
  },
  actions: {
    SOCKET_() {
        // do something
        alert("Actions")
    }
}
});
